import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress
} from '@mui/material';

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  content: string;
  isSubmitting: boolean;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  isSubmitting
}) => {
  return (
  <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title" sx={{ fontSize: '1.1rem' }}>
      {title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description" sx={{ fontSize: '0.875rem' }}>
        {content}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={isSubmitting} sx={{ fontSize: '0.875rem' }}>Anuluj</Button>
      <Button onClick={onConfirm}  color="error" autoFocus disabled={isSubmitting}
              startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
              sx={{ fontSize: '0.875rem' }}
      >
        {isSubmitting ? 'Usuwanie...' : 'Usuń'}
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default DeleteConfirmDialog;
